import { render, staticRenderFns } from "./87.vue?vue&type=template&id=0900f1c4&scoped=true&"
var script = {}
import style0 from "./87.vue?vue&type=style&index=0&id=0900f1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900f1c4",
  null
  
)

export default component.exports